var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useMemo } from "react";
import { Box, CircularProgress, FormControl, Grid, MenuItem, Select, Stack, styled, Typography, Radio, Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { colors } from "../../Themes/colors";
import { DolarIcon } from "../../components/icons";
import FilesIcon from "../../components/icons/FilesIcon";
import MUIDatePicker from "../../components/FormComponents/DatePicker";
import moment from "moment";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { validateDate } from "../../utils/commonUtilities";
import { utility } from "../../utils";
import constants from "../../config/constants";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler, } from "chart.js";
import { Line } from "react-chartjs-2";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);
var DashboardCard = styled(Stack)({
    borderRadius: 8,
    overflow: "hidden",
    border: "1px solid ".concat(colors.greyShades[18]),
    "& .dashboardCardHeader": {
        padding: 16,
        display: "flex",
        alignItems: "center",
        backgroundColor: colors.blueShades[11],
        gap: 8,
    },
    "& .dashboardCardContent": {
        padding: 16,
    },
});
var getPaymentLabel = function (count, singular, plural) {
    return Math.abs(count) === 1 ? singular : plural;
};
var CustomerPortalDashboard = function () {
    var getInitialDates = function () {
        var today = moment().format("YYYY-MM-DD");
        var weeklyFromDate = moment().subtract(6, "days").format("YYYY-MM-DD");
        return { fromDate: weeklyFromDate, toDate: today };
    };
    var _a = getInitialDates(), initialFromDate = _a.fromDate, initialToDate = _a.toDate;
    var _b = useState(initialFromDate), paymentsFromDate = _b[0], setPaymentsFromDate = _b[1];
    var _c = useState(initialToDate), paymentsToDate = _c[0], setPaymentsToDate = _c[1];
    var _d = useState("weekly"), paymentsPeriod = _d[0], setPaymentsPeriod = _d[1];
    var _e = useState("dropdown"), paymentsFilterType = _e[0], setPaymentsFilterType = _e[1];
    var _f = useState([]), paymentsData = _f[0], setPaymentsData = _f[1];
    var _g = useState(false), paymentsLoading = _g[0], setPaymentsLoading = _g[1];
    var _h = useState(initialFromDate), documentsFromDate = _h[0], setDocumentsFromDate = _h[1];
    var _j = useState(initialToDate), documentsToDate = _j[0], setDocumentsToDate = _j[1];
    var _k = useState("weekly"), documentsPeriod = _k[0], setDocumentsPeriod = _k[1];
    var _l = useState("dropdown"), documentsFilterType = _l[0], setDocumentsFilterType = _l[1];
    var _m = useState([]), documentsData = _m[0], setDocumentsData = _m[1];
    var _o = useState(false), documentsLoading = _o[0], setDocumentsLoading = _o[1];
    var _p = useState("day"), paymentsGroupingType = _p[0], setPaymentsGroupingType = _p[1];
    var _q = useState("day"), documentsGroupingType = _q[0], setDocumentsGroupingType = _q[1];
    var fetchDashboardStats = function (fromDate, toDate) { return __awaiter(void 0, void 0, void 0, function () {
        var from, to, response, apiData_1, transformedPaymentsData, error_1, errorMessage, isNetworkError;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setPaymentsLoading(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    if (!fromDate || !toDate) {
                        throw new Error("Please select both from and to dates");
                    }
                    from = moment(fromDate);
                    to = moment(toDate);
                    if (!from.isValid() || !to.isValid()) {
                        throw new Error("Invalid date format");
                    }
                    if (from.isAfter(to)) {
                        throw new Error("From date cannot be after To date");
                    }
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_DASHBOARD_STATS_FOR_PAYMENTS,
                            payLoad: {
                                fromDate: fromDate,
                                toDate: toDate,
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiData_1 = response.data;
                        setPaymentsGroupingType(apiData_1.data.payments.groupingType);
                        transformedPaymentsData = apiData_1.data.payments.paymentsData.map(function (item) {
                            var dateStr = "";
                            if (apiData_1.data.payments.groupingType === "day" && item.date) {
                                dateStr = item.date;
                            }
                            else if (apiData_1.data.payments.groupingType === "week" &&
                                item.weekStarting) {
                                dateStr = item.weekStarting;
                            }
                            else if (apiData_1.data.payments.groupingType === "month" &&
                                item.month) {
                                dateStr = "".concat(item.month, "-01");
                            }
                            return {
                                date: dateStr,
                                created: item.processingCount || 0,
                                customerCancelled: item.cancelledCount || 0,
                            };
                        });
                        setPaymentsData(transformedPaymentsData);
                    }
                    else {
                        throw new Error(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch dashboard statistics");
                    }
                    return [3, 5];
                case 3:
                    error_1 = _d.sent();
                    console.error("Error fetching payments dashboard statistics:", error_1);
                    errorMessage = ((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                        "Failed to fetch payments dashboard statistics";
                    isNetworkError = typeof errorMessage === "string" &&
                        (errorMessage.toLowerCase().includes("internet") ||
                            errorMessage.toLowerCase().includes("connection") ||
                            errorMessage === "Network Error");
                    if (!isNetworkError) {
                        utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    }
                    setPaymentsData([]);
                    return [3, 5];
                case 4:
                    setPaymentsLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var fetchDocumentsStats = function (fromDate, toDate) { return __awaiter(void 0, void 0, void 0, function () {
        var from, to, response, apiData_2, transformedDocumentsData, error_2, errorMessage, isNetworkError;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    setDocumentsLoading(true);
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, 4, 5]);
                    if (!fromDate || !toDate) {
                        throw new Error("Please select both from and to dates");
                    }
                    from = moment(fromDate);
                    to = moment(toDate);
                    if (!from.isValid() || !to.isValid()) {
                        throw new Error("Invalid date format");
                    }
                    if (from.isAfter(to)) {
                        throw new Error("From date cannot be after To date");
                    }
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_DASHBOARD_STATS_FOR_DOCUMENTS,
                            payLoad: {
                                fromDate: fromDate,
                                toDate: toDate,
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _h.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiData_2 = response.data;
                        setDocumentsGroupingType(((_b = (_a = apiData_2.data) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.groupingType) || "day");
                        transformedDocumentsData = (((_d = (_c = apiData_2.data) === null || _c === void 0 ? void 0 : _c.documents) === null || _d === void 0 ? void 0 : _d.documentsData) || []).map(function (item) {
                            var _a, _b, _c, _d, _e, _f;
                            var dateStr = "";
                            if (((_b = (_a = apiData_2.data) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.groupingType) === "day" && item.date) {
                                dateStr = item.date;
                            }
                            else if (((_d = (_c = apiData_2.data) === null || _c === void 0 ? void 0 : _c.documents) === null || _d === void 0 ? void 0 : _d.groupingType) === "week" &&
                                item.weekStarting) {
                                dateStr = item.weekStarting;
                            }
                            else if (((_f = (_e = apiData_2.data) === null || _e === void 0 ? void 0 : _e.documents) === null || _f === void 0 ? void 0 : _f.groupingType) === "month" &&
                                item.month) {
                                dateStr = "".concat(item.month, "-01");
                            }
                            return {
                                date: dateStr,
                                uploadedCount: item.uploadedCount || 0,
                            };
                        });
                        setDocumentsData(transformedDocumentsData);
                    }
                    else {
                        throw new Error(((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.message) || "Failed to fetch documents statistics");
                    }
                    return [3, 5];
                case 3:
                    error_2 = _h.sent();
                    console.error("Error fetching documents dashboard statistics:", error_2);
                    errorMessage = ((_g = (_f = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.message) ||
                        (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                        "Failed to fetch documents dashboard statistics";
                    isNetworkError = typeof errorMessage === "string" &&
                        (errorMessage.toLowerCase().includes("internet") ||
                            errorMessage.toLowerCase().includes("connection") ||
                            errorMessage === "Network Error");
                    if (!isNetworkError) {
                        utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    }
                    setDocumentsData([]);
                    return [3, 5];
                case 4:
                    setDocumentsLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var calculateDateRange = function (period) {
        var today = moment().startOf("day").format("YYYY-MM-DD");
        switch (period) {
            case "daily":
                return { fromDate: today, toDate: today };
            case "weekly":
                return {
                    fromDate: moment()
                        .startOf("day")
                        .subtract(6, "days")
                        .format("YYYY-MM-DD"),
                    toDate: today,
                };
            case "monthly":
                return {
                    fromDate: moment()
                        .startOf("day")
                        .subtract(29, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment(new Date()).format("YYYY-MM-DD"),
                };
            case "yearly":
                return {
                    fromDate: moment()
                        .startOf("day")
                        .subtract(364, "days")
                        .format("YYYY-MM-DD"),
                    toDate: today,
                };
            default:
                return { fromDate: today, toDate: today };
        }
    };
    var handlePaymentsPeriodChange = function (value) {
        setPaymentsPeriod(value);
        var _a = calculateDateRange(value), fromDate = _a.fromDate, toDate = _a.toDate;
        setPaymentsFromDate(fromDate);
        setPaymentsToDate(toDate);
    };
    var handleDocumentsPeriodChange = function (value) {
        setDocumentsPeriod(value);
        var _a = calculateDateRange(value), fromDate = _a.fromDate, toDate = _a.toDate;
        setDocumentsFromDate(fromDate);
        setDocumentsToDate(toDate);
    };
    useEffect(function () {
        if (paymentsFilterType === "dropdown" &&
            paymentsPeriod &&
            paymentsFromDate &&
            paymentsToDate) {
            fetchDashboardStats(paymentsFromDate, paymentsToDate);
        }
        else if (paymentsFilterType === "datepicker" &&
            paymentsFromDate &&
            paymentsToDate) {
            fetchDashboardStats(paymentsFromDate, paymentsToDate);
        }
    }, [paymentsFromDate, paymentsToDate, paymentsFilterType, paymentsPeriod]);
    useEffect(function () {
        if (documentsFilterType === "dropdown" &&
            documentsPeriod &&
            documentsFromDate &&
            documentsToDate) {
            fetchDocumentsStats(documentsFromDate, documentsToDate);
        }
        else if (documentsFilterType === "datepicker" &&
            documentsFromDate &&
            documentsToDate) {
            fetchDocumentsStats(documentsFromDate, documentsToDate);
        }
    }, [
        documentsFromDate,
        documentsToDate,
        documentsFilterType,
        documentsPeriod,
    ]);
    var getDateRangeConfig = function (fromDate, toDate) {
        var days = moment(toDate).diff(moment(fromDate), "days");
        if (days <= 30) {
            return {
                aggregation: "day",
                labelFormat: "MM-DD",
                maxDataPoints: 30,
                labelStep: 1,
            };
        }
        else if (days <= 365) {
            return {
                aggregation: "week",
                labelFormat: "MM-DD",
                maxDataPoints: 52,
                labelStep: Math.ceil(days / 30),
            };
        }
        else if (days <= 1095) {
            return {
                aggregation: "month",
                labelFormat: "MM-YYYY",
                maxDataPoints: 36,
                labelStep: 1,
            };
        }
        else {
            return {
                aggregation: days > 1825 ? "year" : "quarter",
                labelFormat: "YYYY",
                maxDataPoints: days > 1825 ? Math.ceil(days / 365) : Math.ceil(days / 90),
                labelStep: days > 3650 ? 2 : 1,
            };
        }
    };
    var aggregateData = function (data, aggregation, getValue) {
        if (!data.length)
            return [];
        var grouped = new Map();
        data.forEach(function (item) {
            var key;
            var date = moment(item.date);
            switch (aggregation) {
                case "day":
                    key = date.format("YYYY-MM-DD");
                    break;
                case "week":
                    key = date.startOf("week").format("YYYY-MM-DD");
                    break;
                case "month":
                    key = date.startOf("month").format("YYYY-MM");
                    break;
                case "quarter":
                    key = date.startOf("quarter").format("YYYY-MM");
                    break;
                case "year":
                    key = date.startOf("year").format("YYYY");
                    break;
                default:
                    key = date.format("YYYY-MM-DD");
            }
            var existing = grouped.get(key) || { sum: 0, count: 0 };
            grouped.set(key, {
                sum: existing.sum + getValue(item),
                count: existing.count + 1,
            });
        });
        return Array.from(grouped.entries())
            .map(function (_a) {
            var date = _a[0], _b = _a[1], sum = _b.sum, count = _b.count;
            return ({
                date: date,
                value: sum / count,
            });
        })
            .sort(function (a, b) { return a.date.localeCompare(b.date); });
    };
    var generateAllPeriods = function (fromDate, toDate, groupingType) {
        var periods = [];
        var start = moment(fromDate).startOf("day");
        var end = moment(toDate).startOf("day");
        if (groupingType === "day") {
            var current = moment(start);
            while (current.isSameOrBefore(end, "day")) {
                periods.push(current.format("YYYY-MM-DD"));
                current.add(1, "day");
            }
        }
        else if (groupingType === "week") {
            var current = moment(start).startOf("week");
            var endWeek = moment(end).startOf("week");
            while (current.isSameOrBefore(endWeek, "day")) {
                periods.push(current.format("YYYY-MM-DD"));
                current.add(1, "week");
            }
        }
        else if (groupingType === "month") {
            var current = moment(start).startOf("month");
            var endMonth = moment(end).startOf("month");
            while (current.isSameOrBefore(endMonth, "day")) {
                periods.push(current.format("YYYY-MM"));
                current.add(1, "month");
            }
        }
        return periods;
    };
    var paymentsChartData = useMemo(function () {
        var processedTotal = paymentsData.reduce(function (sum, item) { return sum + (item.created || 0); }, 0);
        var cancelledTotal = paymentsData.reduce(function (sum, item) { return sum + (item.customerCancelled || 0); }, 0);
        var processedLabel = getPaymentLabel(processedTotal, "Processed Payment", "Processed Payments");
        var cancelledLabel = getPaymentLabel(cancelledTotal, "Cancelled Payment", "Cancelled Payments");
        if (!paymentsFromDate || !paymentsToDate) {
            return {
                labels: [],
                datasets: [
                    {
                        label: processedLabel,
                        data: [],
                        borderColor: "#FF69B4",
                        backgroundColor: "rgba(255, 105, 180, 0.1)",
                        fill: false,
                        tension: 0.4,
                        pointRadius: 4,
                        pointHoverRadius: 8,
                        pointHoverBorderWidth: 2,
                        pointBackgroundColor: "#FF69B4",
                        pointBorderColor: "#FF69B4",
                        pointHoverBackgroundColor: "#FF69B4",
                        pointHoverBorderColor: "#fff",
                    },
                    {
                        label: cancelledLabel,
                        data: [],
                        borderColor: "#4169E1",
                        backgroundColor: "rgba(65, 105, 225, 0.1)",
                        fill: false,
                        tension: 0.4,
                        pointRadius: 4,
                        pointHoverRadius: 8,
                        pointHoverBorderWidth: 2,
                        pointBackgroundColor: "#4169E1",
                        pointBorderColor: "#4169E1",
                        pointHoverBackgroundColor: "#4169E1",
                        pointHoverBorderColor: "#fff",
                    },
                ],
            };
        }
        var allPeriods = generateAllPeriods(paymentsFromDate, paymentsToDate, paymentsGroupingType);
        var dataMap = new Map();
        paymentsData.forEach(function (item) {
            var key = "";
            if (paymentsGroupingType === "day") {
                key = moment(item.date).startOf("day").format("YYYY-MM-DD");
            }
            else if (paymentsGroupingType === "week") {
                var parsedDate = moment(item.date);
                if (!parsedDate.isValid()) {
                    console.warn("Invalid date in API response:", item.date);
                    return;
                }
                key = parsedDate.startOf("week").startOf("day").format("YYYY-MM-DD");
            }
            else if (paymentsGroupingType === "month") {
                var monthDate = moment(item.date);
                key = monthDate.format("YYYY-MM");
            }
            if (key) {
                dataMap.set(key, {
                    created: item.created,
                    customerCancelled: item.customerCancelled,
                });
            }
        });
        var labelFormat = "MM-DD-YYYY";
        if (paymentsGroupingType === "month") {
            labelFormat = "MM-YYYY";
        }
        else if (paymentsGroupingType === "week") {
            labelFormat = "MM-DD-YYYY";
        }
        else {
            labelFormat = "MM-DD-YYYY";
        }
        var labels = [];
        var createdData = [];
        var cancelledData = [];
        allPeriods.forEach(function (period) {
            var data = dataMap.get(period) || { created: 0, customerCancelled: 0 };
            var label = "";
            if (paymentsGroupingType === "day") {
                label = moment(period).format(labelFormat);
            }
            else if (paymentsGroupingType === "week") {
                label = moment(period).format(labelFormat);
            }
            else if (paymentsGroupingType === "month") {
                label = moment("".concat(period, "-01")).format(labelFormat);
            }
            labels.push(label);
            createdData.push(data.created);
            cancelledData.push(data.customerCancelled);
        });
        var chartData = {
            labels: labels,
            datasets: [
                {
                    label: processedLabel,
                    data: createdData,
                    borderColor: "#FF69B4",
                    backgroundColor: "rgba(255, 105, 180, 0.1)",
                    fill: false,
                    tension: 0.4,
                    pointRadius: paymentsGroupingType === "day" ? 4 : 3,
                    pointHoverRadius: 8,
                    pointHoverBorderWidth: 2,
                    pointBackgroundColor: "#FF69B4",
                    pointBorderColor: "#FF69B4",
                    pointHoverBackgroundColor: "#FF69B4",
                    pointHoverBorderColor: "#fff",
                },
                {
                    label: cancelledLabel,
                    data: cancelledData,
                    borderColor: "#4169E1",
                    backgroundColor: "rgba(65, 105, 225, 0.1)",
                    fill: false,
                    tension: 0.4,
                    pointRadius: paymentsGroupingType === "day" ? 4 : 3,
                    pointHoverRadius: 8,
                    pointHoverBorderWidth: 2,
                    pointBackgroundColor: "#4169E1",
                    pointBorderColor: "#4169E1",
                    pointHoverBackgroundColor: "#4169E1",
                    pointHoverBorderColor: "#fff",
                },
            ],
        };
        chartData.config = {
            labelFormat: labelFormat,
            labelStep: 1,
        };
        return chartData;
    }, [paymentsData, paymentsFromDate, paymentsToDate, paymentsGroupingType]);
    var documentsChartData = useMemo(function () {
        if (!documentsFromDate || !documentsToDate) {
            return {
                labels: [],
                datasets: [
                    {
                        label: "Uploaded",
                        data: [],
                        borderColor: "#4169E1",
                        backgroundColor: "rgba(255, 105, 180, 0.1)",
                        fill: false,
                        tension: 0.4,
                        pointRadius: 4,
                        pointHoverRadius: 8,
                        pointHoverBorderWidth: 2,
                        pointBackgroundColor: "#4169E1",
                        pointBorderColor: "#4169E1",
                        pointHoverBackgroundColor: "#4169E1",
                        pointHoverBorderColor: "#fff",
                    },
                ],
            };
        }
        var allPeriods = generateAllPeriods(documentsFromDate, documentsToDate, documentsGroupingType);
        var dataMap = new Map();
        documentsData.forEach(function (item) {
            var key = "";
            if (documentsGroupingType === "day") {
                key = moment(item.date).startOf("day").format("YYYY-MM-DD");
            }
            else if (documentsGroupingType === "week") {
                var parsedDate = moment(item.date);
                if (!parsedDate.isValid()) {
                    console.warn("Invalid date in API response:", item.date);
                    return;
                }
                key = parsedDate.startOf("week").startOf("day").format("YYYY-MM-DD");
            }
            else if (documentsGroupingType === "month") {
                var monthDate = moment(item.date);
                key = monthDate.format("YYYY-MM");
            }
            if (key) {
                dataMap.set(key, item.uploadedCount);
            }
        });
        var labelFormat = "MM-DD-YYYY";
        if (documentsGroupingType === "month") {
            labelFormat = "MM-YYYY";
        }
        else if (documentsGroupingType === "week") {
            labelFormat = "MM-DD-YYYY";
        }
        else {
            labelFormat = "MM-DD-YYYY";
        }
        var labels = [];
        var uploadedData = [];
        allPeriods.forEach(function (period) {
            var uploadedCount = dataMap.get(period) || 0;
            var label = "";
            if (documentsGroupingType === "day") {
                label = moment(period).format(labelFormat);
            }
            else if (documentsGroupingType === "week") {
                label = moment(period).format(labelFormat);
            }
            else if (documentsGroupingType === "month") {
                label = moment("".concat(period, "-01")).format(labelFormat);
            }
            labels.push(label);
            uploadedData.push(uploadedCount);
        });
        var chartData = {
            labels: labels,
            datasets: [
                {
                    label: "Uploaded",
                    data: uploadedData,
                    borderColor: "#4169E1",
                    backgroundColor: "rgba(255, 105, 180, 0.1)",
                    fill: false,
                    tension: 0.4,
                    pointRadius: documentsGroupingType === "day" ? 4 : 3,
                    pointHoverRadius: 8,
                    pointHoverBorderWidth: 2,
                    pointBackgroundColor: "#4169E1",
                    pointBorderColor: "#4169E1",
                    pointHoverBackgroundColor: "#4169E1",
                    pointHoverBorderColor: "#fff",
                },
            ],
        };
        chartData.config = {
            labelFormat: labelFormat,
            labelStep: 1,
        };
        return chartData;
    }, [
        documentsData,
        documentsFromDate,
        documentsToDate,
        documentsGroupingType,
    ]);
    var getMaxYValue = function (data) {
        var max = Math.max.apply(Math, __spreadArray(__spreadArray([], data, false), [0], false));
        if (max === 0)
            return 4;
        var roundedMax = Math.ceil(max);
        if (roundedMax <= 4) {
            return 4;
        }
        else if (roundedMax <= 8) {
            return 8;
        }
        else if (roundedMax <= 12) {
            return 12;
        }
        else if (roundedMax <= 16) {
            return 16;
        }
        else if (roundedMax <= 20) {
            return 20;
        }
        else {
            return Math.ceil(roundedMax / 4) * 4;
        }
    };
    var getStepSize = function (maxY) {
        if (maxY <= 0)
            return 1;
        return maxY / 4;
    };
    var paymentsMaxY = useMemo(function () {
        if (!paymentsData.length)
            return 4;
        var allValues = __spreadArray(__spreadArray([], paymentsData.map(function (d) { return d.created; }), true), paymentsData.map(function (d) { return d.customerCancelled; }), true);
        return getMaxYValue(allValues);
    }, [paymentsData]);
    var documentsMaxY = useMemo(function () {
        if (!documentsData.length)
            return 4;
        var allValues = documentsData.map(function (d) { return d.uploadedCount; });
        return getMaxYValue(allValues);
    }, [documentsData]);
    var chartOptions = function (maxY, config, onLabelClick) {
        if (maxY === void 0) { maxY = 4; }
        return ({
            responsive: true,
            maintainAspectRatio: false,
            layout: {
                padding: {
                    top: 10,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
            },
            clip: false,
            onClick: function (event, elements, chart) {
                if (chart && elements.length === 0) {
                    var canvasPosition = chart.getElementsAtEventForMode(event, "nearest", { intersect: false }, true);
                    var xScale = chart.scales.x;
                    var yScale = chart.scales.y;
                    var rect = chart.canvas.getBoundingClientRect();
                    var x = event.clientX - rect.left;
                    var y = event.clientY - rect.top;
                    if (y > yScale.bottom && y < chart.height) {
                        var value = xScale.getValueForPixel(x);
                        if (value !== null &&
                            value >= 0 &&
                            value < chart.data.labels.length) {
                            var clickedLabel = chart.data.labels[Math.round(value)];
                            var clickedIndex = Math.round(value);
                            if (onLabelClick) {
                                onLabelClick(clickedLabel, clickedIndex);
                            }
                        }
                    }
                }
            },
            interaction: {
                mode: "index",
                intersect: false,
            },
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                    align: "center",
                    onClick: function () { },
                    labels: {
                        usePointStyle: true,
                        padding: 16,
                        font: {
                            size: 12,
                        },
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: "index",
                    intersect: false,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    titleColor: "#000",
                    bodyColor: "#000",
                    borderColor: "#e0e0e0",
                    borderWidth: 1,
                    padding: 12,
                    displayColors: true,
                    usePointStyle: true,
                    titleFont: {
                        size: 12,
                        weight: "bold",
                    },
                    bodyFont: {
                        size: 12,
                    },
                    callbacks: {
                        title: function (context) {
                            return context[0].label;
                        },
                        label: function (context) {
                            return "".concat(context.dataset.label, ": ").concat(context.parsed.y.toFixed(2));
                        },
                    },
                },
            },
            scales: {
                x: {
                    grid: {
                        display: true,
                        color: "#e0e0e0",
                        borderDash: [5, 5],
                    },
                    ticks: {
                        maxRotation: (config === null || config === void 0 ? void 0 : config.labelFormat) === "YYYY" ? 0 : 45,
                        minRotation: (config === null || config === void 0 ? void 0 : config.labelFormat) === "YYYY" ? 0 : 45,
                        autoSkip: true,
                        maxTicksLimit: (config === null || config === void 0 ? void 0 : config.labelStep)
                            ? Math.ceil(30 / config.labelStep)
                            : 20,
                        font: {
                            size: (config === null || config === void 0 ? void 0 : config.labelFormat) === "YYYY" ? 10 : 11,
                        },
                        color: "#666",
                    },
                },
                y: {
                    beginAtZero: true,
                    max: maxY,
                    ticks: {
                        stepSize: getStepSize(maxY),
                        font: {
                            size: 11,
                        },
                        color: "#666",
                    },
                    grid: {
                        display: true,
                        color: "#e0e0e0",
                        borderDash: [5, 5],
                    },
                },
            },
        });
    };
    var handleOpenAnalytics = function () {
        window.open("https://analytics.google.com/analytics/web/#/a296721104p516802639/reports/explorer?params=_u..nav%3Dmaui&ruid=top-events,business-objectives,examine-user-behavior&collectionId=business-objectives&r=top-events", "_blank");
    };
    return (React.createElement(Stack, { sx: { p: 3 } },
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", pb: 2 },
            React.createElement(Typography, { variant: "h5", fontWeight: 600 }, "Dashboard"),
            React.createElement(Button, { variant: "outlined", size: "medium", onClick: handleOpenAnalytics, endIcon: React.createElement(OpenInNewIcon, null), sx: {
                    textTransform: "none",
                    borderRadius: "8px",
                    borderColor: "#1A1A1A",
                    color: "#000000",
                    "&:hover": {
                        borderColor: "#000000",
                        backgroundColor: "#F5F5F5",
                    },
                } }, "Google Analytics")),
        React.createElement(Grid, { container: true, spacing: 2, alignItems: "stretch" },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(DashboardCard, { sx: { height: "100%" } },
                    React.createElement(Stack, { direction: "row", className: "dashboardCardHeader" },
                        React.createElement(DolarIcon, null),
                        React.createElement(Typography, { variant: "h6", fontWeight: 600, color: colors.fullWhite }, "Payments")),
                    React.createElement(Stack, { className: "dashboardCardContent" },
                        React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "flex-end", flexWrap: "wrap", justifyContent: "flex-end", marginRight: "10px", sx: {
                                "& .MuiInputBase-root": { borderRadius: "8px" },
                                "& .clear-date": { right: "0 !important" },
                                "& .MuiInputAdornment-root": {
                                    "& .MuiButtonBase-root": { marginLeft: "-8px" },
                                },
                            } },
                            React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { marginBottom: "4px !important" } },
                                React.createElement(Radio, { size: "small", checked: paymentsFilterType === "dropdown", onChange: function () {
                                        setPaymentsFilterType("dropdown");
                                        setPaymentsPeriod("weekly");
                                        var _a = calculateDateRange("weekly"), fromDate = _a.fromDate, toDate = _a.toDate;
                                        setPaymentsFromDate(fromDate);
                                        setPaymentsToDate(toDate);
                                    } }),
                                React.createElement(FormControl, { size: "small", sx: { minWidth: 120 } },
                                    React.createElement(Select, { value: paymentsPeriod, onChange: function (e) {
                                            handlePaymentsPeriodChange(e.target.value);
                                        }, disabled: paymentsFilterType !== "dropdown", sx: {
                                            borderRadius: "8px",
                                            bgcolor: "#fff",
                                            height: 36,
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#a3a9b9",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#a3a9b9",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#a3a9b9",
                                                borderWidth: "1px",
                                            },
                                        } },
                                        React.createElement(MenuItem, { value: "daily" }, "Daily"),
                                        React.createElement(MenuItem, { value: "weekly" }, "Weekly"),
                                        React.createElement(MenuItem, { value: "monthly" }, "Monthly"),
                                        React.createElement(MenuItem, { value: "yearly" }, "Yearly")))),
                            React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "end" },
                                React.createElement(Box, { sx: {
                                        marginBottom: "5px",
                                    } },
                                    React.createElement(Radio, { size: "small", sx: {
                                            marginBottom: "5px",
                                        }, checked: paymentsFilterType === "datepicker", onChange: function () {
                                            setPaymentsFilterType("datepicker");
                                            var today = moment().format("YYYY-MM-DD");
                                            var sevenDaysAgo = moment()
                                                .subtract(6, "days")
                                                .format("YYYY-MM-DD");
                                            setPaymentsFromDate(sevenDaysAgo);
                                            setPaymentsToDate(today);
                                        } })),
                                React.createElement(Box, { sx: {
                                        width: 160,
                                        "& .MuiInputBase-root": { bgcolor: "#fff" },
                                    } },
                                    React.createElement(MUIDatePicker, { key: "payments-from-".concat(paymentsFromDate, "-").concat(paymentsFilterType), labelText: "Start Date", isMandatory: false, selectedDate: paymentsFilterType === "dropdown"
                                            ? ""
                                            : paymentsFromDate, disabled: paymentsFilterType !== "datepicker", errorMessage: "", maxDate: paymentsToDate || undefined, dateChangeHandler: function (date) {
                                            if (paymentsFilterType !== "datepicker")
                                                return;
                                            if (date == null || date === "") {
                                                setPaymentsFromDate("");
                                                return;
                                            }
                                            var dateValidation = validateDate(date);
                                            if (!dateValidation.isValid) {
                                                utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                                setPaymentsFromDate("");
                                                return;
                                            }
                                            var formattedDate = moment(date).format("YYYY-MM-DD");
                                            if (paymentsToDate &&
                                                moment(formattedDate).isAfter(moment(paymentsToDate))) {
                                                utility.alert("Start date cannot be after end date.", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            setPaymentsFromDate(formattedDate);
                                        } })),
                                React.createElement(Box, { sx: {
                                        width: 160,
                                        "& .MuiInputBase-root": { bgcolor: "#fff" },
                                    } },
                                    React.createElement(MUIDatePicker, { key: "payments-to-".concat(paymentsFromDate, "-").concat(paymentsToDate, "-").concat(paymentsFilterType), labelText: "End Date", isMandatory: false, minDate: paymentsFromDate || undefined, selectedDate: paymentsFilterType === "dropdown" ? "" : paymentsToDate, disabled: paymentsFilterType !== "datepicker", errorMessage: "", dateChangeHandler: function (date) {
                                            if (paymentsFilterType !== "datepicker")
                                                return;
                                            if (date == null || date === "") {
                                                setPaymentsToDate("");
                                                return;
                                            }
                                            var dateValidation = validateDate(date);
                                            if (!dateValidation.isValid) {
                                                utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                                setPaymentsToDate("");
                                                return;
                                            }
                                            var formattedDate = moment(date).format("YYYY-MM-DD");
                                            if (paymentsFromDate &&
                                                moment(formattedDate).isBefore(moment(paymentsFromDate))) {
                                                utility.alert("End date cannot be before start date.", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            setPaymentsToDate(formattedDate);
                                        } })))),
                        React.createElement(Stack, { sx: { mt: 2, height: 420, position: "relative" } }, paymentsLoading ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { height: "100%" } },
                            React.createElement(CircularProgress, null))) : !(paymentsData === null || paymentsData === void 0 ? void 0 : paymentsData.length) ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { height: "100%", color: "text.secondary" } },
                            React.createElement(Typography, { variant: "body1" }, "No Data Available"))) : (React.createElement(Line, { data: paymentsChartData, options: chartOptions(paymentsMaxY, paymentsChartData.config, function (label, index) {
                                console.log("Clicked payments label:", label, "Index:", index);
                            }) })))))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(DashboardCard, { sx: { height: "100%" } },
                    React.createElement(Stack, { direction: "row", className: "dashboardCardHeader" },
                        React.createElement(Stack, { sx: {
                                alignItems: "center",
                                "& svg": {
                                    "& path": {
                                        stroke: colors.fullWhite,
                                    },
                                },
                            } },
                            React.createElement(FilesIcon, null)),
                        React.createElement(Typography, { variant: "h6", fontWeight: 600, color: colors.fullWhite }, "Documents")),
                    React.createElement(Stack, { className: "dashboardCardContent" },
                        React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "flex-end", flexWrap: "wrap", marginRight: "10px", justifyContent: "flex-end", sx: {
                                "& .MuiInputBase-root": { borderRadius: "8px" },
                                "& .clear-date": { right: "0 !important" },
                                "& .MuiInputAdornment-root": {
                                    "& .MuiButtonBase-root": { marginLeft: "-8px" },
                                },
                            } },
                            React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { marginBottom: "4px !important" } },
                                React.createElement(Radio, { size: "small", checked: documentsFilterType === "dropdown", onChange: function () {
                                        setDocumentsFilterType("dropdown");
                                        setDocumentsPeriod("weekly");
                                        var _a = calculateDateRange("weekly"), fromDate = _a.fromDate, toDate = _a.toDate;
                                        setDocumentsFromDate(fromDate);
                                        setDocumentsToDate(toDate);
                                    } }),
                                React.createElement(FormControl, { size: "small", sx: { minWidth: 120 } },
                                    React.createElement(Select, { value: documentsPeriod, onChange: function (e) {
                                            handleDocumentsPeriodChange(e.target.value);
                                        }, disabled: documentsFilterType !== "dropdown", sx: {
                                            borderRadius: "8px",
                                            bgcolor: "#fff",
                                            height: 36,
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#a3a9b9",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#a3a9b9",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#a3a9b9",
                                                borderWidth: "1px",
                                            },
                                        } },
                                        React.createElement(MenuItem, { value: "daily" }, "Daily"),
                                        React.createElement(MenuItem, { value: "weekly" }, "Weekly"),
                                        React.createElement(MenuItem, { value: "monthly" }, "Monthly"),
                                        React.createElement(MenuItem, { value: "yearly" }, "Yearly")))),
                            React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "end" },
                                React.createElement(Box, { sx: {
                                        marginBottom: "5px",
                                    } },
                                    " ",
                                    React.createElement(Radio, { sx: {
                                            marginBottom: "5px",
                                        }, size: "small", checked: documentsFilterType === "datepicker", onChange: function () {
                                            setDocumentsFilterType("datepicker");
                                            var today = moment().format("YYYY-MM-DD");
                                            var sevenDaysAgo = moment()
                                                .subtract(6, "days")
                                                .format("YYYY-MM-DD");
                                            setDocumentsFromDate(sevenDaysAgo);
                                            setDocumentsToDate(today);
                                        } })),
                                React.createElement(Box, { sx: {
                                        width: 160,
                                        "& .MuiInputBase-root": { bgcolor: "#fff" },
                                    } },
                                    React.createElement(MUIDatePicker, { key: "documents-from-".concat(documentsFromDate, "-").concat(documentsFilterType), labelText: "Start Date", isMandatory: false, selectedDate: documentsFilterType === "dropdown"
                                            ? ""
                                            : documentsFromDate, disabled: documentsFilterType !== "datepicker", errorMessage: "", maxDate: documentsToDate || undefined, dateChangeHandler: function (date) {
                                            if (documentsFilterType !== "datepicker")
                                                return;
                                            if (date == null || date === "") {
                                                setDocumentsFromDate("");
                                                return;
                                            }
                                            var dateValidation = validateDate(date);
                                            if (!dateValidation.isValid) {
                                                utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                                setDocumentsFromDate("");
                                                return;
                                            }
                                            var formattedDate = moment(date).format("YYYY-MM-DD");
                                            if (documentsToDate &&
                                                moment(formattedDate).isAfter(moment(documentsToDate))) {
                                                utility.alert("Start date cannot be after end date.", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            setDocumentsFromDate(formattedDate);
                                        } })),
                                React.createElement(Box, { sx: {
                                        width: 160,
                                        "& .MuiInputBase-root": { bgcolor: "#fff" },
                                    } },
                                    React.createElement(MUIDatePicker, { key: "documents-to-".concat(documentsFromDate, "-").concat(documentsToDate, "-").concat(documentsFilterType), labelText: "End Date", isMandatory: false, minDate: documentsFromDate || undefined, selectedDate: documentsFilterType === "dropdown"
                                            ? ""
                                            : documentsToDate, disabled: documentsFilterType !== "datepicker", errorMessage: "", dateChangeHandler: function (date) {
                                            if (documentsFilterType !== "datepicker")
                                                return;
                                            if (date == null || date === "") {
                                                setDocumentsToDate("");
                                                return;
                                            }
                                            var dateValidation = validateDate(date);
                                            if (!dateValidation.isValid) {
                                                utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                                setDocumentsToDate("");
                                                return;
                                            }
                                            var formattedDate = moment(date).format("YYYY-MM-DD");
                                            if (documentsFromDate &&
                                                moment(formattedDate).isBefore(moment(documentsFromDate))) {
                                                utility.alert("End date cannot be before start date.", constants.TOAST_TYPES.ERROR);
                                                return;
                                            }
                                            setDocumentsToDate(formattedDate);
                                        } })))),
                        React.createElement(Stack, { sx: { mt: 2, height: 420, position: "relative" } }, documentsLoading ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { height: "100%" } },
                            React.createElement(CircularProgress, null))) : !(documentsData === null || documentsData === void 0 ? void 0 : documentsData.length) ? (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { height: "100%", color: "text.secondary" } },
                            React.createElement(Typography, { variant: "body1" }, "No Data Available"))) : (React.createElement(Line, { data: documentsChartData, options: chartOptions(documentsMaxY, documentsChartData.config, function (label, index) {
                                console.log("Clicked label:", label, "Index:", index);
                            }) })))))))));
};
export default CustomerPortalDashboard;
